module.exports = __webpack_public_path__ + "static/img/szafa_12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_12.jpg
// module id = FBu1
// module chunks = 0